import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import ResourcesTab from "@/components/briefing/ResourcesTab";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ResourcesPage() {
  const [settings, setSettings] = useState(null);
  const saveTimer = useRef(null);

  useEffect(() => {
    api.get("/settings/resources")
      .then((r) => setSettings(r.data))
      .catch(() => setSettings({ customSites: [], siteSubs: {}, siteCreds: {} }));
  }, []);

  const update = (updater) => {
    setSettings((prev) => {
      const next = typeof updater === "function" ? updater(prev) : updater;
      if (saveTimer.current) clearTimeout(saveTimer.current);
      saveTimer.current = setTimeout(() => {
        api.put("/settings/resources", {
          customSites: next.customSites || [],
          siteSubs: next.siteSubs || {},
          siteCreds: next.siteCreds || {},
        }).catch(() => toast.error("Échec de l'enregistrement des ressources"));
      }, 600);
      return next;
    });
  };

  if (!settings) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-cyan-400" />
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="resources-page">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl">Ressources</h1>
        <p className="mt-1 text-sm text-slate-400">
          Sites web de référence communs à tous vos briefings — associez-les aux sous-items ; les modifications sont enregistrées automatiquement.
        </p>
      </div>
      <ResourcesTab briefing={settings} setBriefing={update} />
    </div>
  );
}
